var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.87 21.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.87,.27l3.13,6.45c.07,.14,.21,.24,.37,.27l7.1,.98c.4,.05,.55,.54,.27,.82l-5.17,4.97c-.12,.11-.17,.27-.14,.43l1.26,7.05c.07,.39-.34,.7-.7,.51l-6.32-3.38c-.14-.08-.31-.08-.45,0l-6.32,3.38c-.35,.19-.77-.11-.7-.51l1.26-7.05c.03-.16-.02-.32-.14-.43L.15,8.78c-.29-.28-.13-.76,.27-.82l7.1-.98c.16-.02,.3-.12,.37-.27L11,.27c.17-.36,.69-.36,.86,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/membership.3f977770fa03285157a75addb4bfb58f.svg";
export { ForwardRef as ReactComponent };